import { getRequest } from '../api-handler';
import { ParameterDetailDto } from './parameter';

export const ParameterApi = {
  getById: (id: number) => getRequest<ParameterDetailDto>(`/parameters/${id}`)
};
